import styled from "styled-components";

export const ProjectFinancialsStyled = styled.div`
  height: 100%;

  .prog-wrap {
    padding: 10px;
    border: 1px solid #eef1f4;
  }

  .deliverable {
    border-bottom: 1px solid #DEDAFB;
    padding: 16px 16px 16px 24px;
    margin: 0 12px;
  }
  .accordian-padding {
    margin: 12px 0 0 20px;
    display: grid;
    gap: 12px;
  }

  .accordian-body {
    display: flex;
    flex-direction: column;
  }

  .sc-bZHSRq.fGiXqY {
    padding-bottom: 28px;
}
`;
